import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';
import { errorHandler } from 'App/utils';

function useFetchPatientPredictiveModelRisk(patientId, patientPredictiveModelEnabled) {
    return useQuery(
        ['patient', patientId, patientPredictiveModelEnabled],
        () => (!patientId || !patientPredictiveModelEnabled ? null : PESService.getPatientPredictiveModelRisk(patientId)),
        {
            onError: errorHandler,
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false
        }
    );
}

export default useFetchPatientPredictiveModelRisk;
